import React, { useEffect, useState } from 'react'
import Header from '../../Core/Header'
import { Section } from '../../Core/Section'
import { editCouriersApi, getCouriersListApi } from '../../Services/Operations/ProductAPI'
import { useSelector } from 'react-redux'

import { Modal, Button } from "react-bootstrap";
import { toast } from 'react-toastify'

const CourierList = () => {

const [courierList,setCourierList]=useState([])
const [showModal,setShowModal]=useState(false)
const [editModal,setEditModal]=useState(false)
const [selectedCourier,setSelectedCourier]=useState(null)




//for editing

const [courierServiceName,setCourierServiceName]=useState("")
const [contactPerson,setContactPerson]=useState("")
const [contactNumber,setContactNumber]=useState("")
const [email,setEmail]=useState("")
const [website,setWebsite]=useState("")
const [addressLine1,setaddressLine1]=useState("")
const [addressLine2,setAddressLine2]=useState("")
const [city,setCity]=useState("")
const [state,setState]=useState("")
const[country,setCountry]=useState("")
const[postalCode,setPostalCode]=useState("")
const[trackingUrl,setTrackingUrl]=useState("")
const[gstNum,setGstNum]=useState("")
const[status,setStatus]=useState(0)

//for editing

 const token = useSelector((state) => state.user.token);


       const [currentPage, setCurrentPage] = useState(1);
     const itemsPerPage = 10;
     
     const indexOfLast = currentPage * itemsPerPage;
     const indexOfFirst = indexOfLast - itemsPerPage;
     
     const currentUsers = courierList.slice(indexOfFirst, indexOfLast);

const fetchCourierList=async()=>{
    try {

        const response=await getCouriersListApi(token)

        console.log("list",response);
        if(response.status===200){
            setCourierList(response.data)
        }
        
        
    } catch (error) {
        console.log(error);
        
    }
}
const handleCloseModal=async()=>{
    setSelectedCourier(null)
    setShowModal(false)

}

const handleOpenEditView=async(sell)=>{
    setEditModal(true)
    setSelectedCourier(sell)
    setCourierServiceName(sell.courierServiceName)
    setContactNumber(sell.contactNumber)
    setContactPerson(sell.contactPerson)
    setEmail(sell.email)
    setWebsite(sell.website)
    setCity(sell.city)
    setaddressLine1(sell.addressLine1)
    setAddressLine2(sell.addressLine2)
    setState(sell.state)
    setCountry(sell.country)
    setPostalCode(sell.postalCode)
    setTrackingUrl(sell.trackingUrl)
    setGstNum(sell.gstNum)
    setStatus(sell.status)

}

const handleSubmit=async(e)=>{
    e.preventDefault()
    const data={
        courierServiceName,contactPerson,contactNumber,email,website,addressLine1,addressLine2,city,
        state,country,postalCode,trackingUrl,gstNum,status
    }
    let id=selectedCourier?.id

    try {
        const response=await editCouriersApi(id,data,token)
        console.log(response);
        if(response.status===200){
            toast.success("Courier updated successfully")
            setEditModal(false)
            setSelectedCourier(null)
        }
        
        
    } catch (error) {
        console.log(error);
        toast.error("failed to update courier")
    }

}

useEffect(() => {
fetchCourierList()
  
}, [selectedCourier])



  return (
    <div>
         <div id="main_content">
              <Header />
              <div className="page">
                <Section />
             <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">Courier List</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">RNDSAN</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Courier List
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>

           <div className="section-body mt-4">
          <div className="container-fluid">
            <div className="tab-content">
              <div className="tab-pane active" id="Sell-all">
                <div className="table-responsive card">
                  <table className="table table-hover table-vcenter table-striped mb-0 text-nowrap">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Courier Name</th>
                        <th>Email</th>
                        <th>GST Number</th>
                        <th>Contact Person</th>
                        <th>Contact Number</th>
                        <th>Address</th>
                        <th>City</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentUsers.map((sell,index) => (
                        <tr key={sell.id}>
                           <td>{indexOfFirst+index+1}</td>
                          <td>{sell.courierServiceName || "N/A"}</td>
                          <td>{sell.email || "N/A"}</td>
                          <td>{sell.gstNumber || "N/A"}</td>
                          <td>
                            {sell.contactPerson
                              || "N/A"}
                          </td>
                          <td>
                            {sell.contactNumber
                              || "N/A"}
                          </td>
                          <td>{sell.addressLine1||"N/A"}</td>

                          <td>{sell.city||"N/A"}</td>
                          <td>{sell.status<1?"Incative":"Active"||"N/A"}</td>
                          
                          <td>
                            <button
                              type="button"
                              className="btn btn-icon btn-sm"
                              title="View"
                                onClick={()=>{
                                    setShowModal(true)
                                    setSelectedCourier(sell)
                                }}
                            >
                              <i className="fa fa-eye" />
                              
                            </button>
                             <button
                              type="button"
                              className="btn btn-icon btn-sm"
                              title="View"
                                onClick={()=>handleOpenEditView(sell)}
                            >
                             
                              <i className="fa fa-edit" />
                            </button>
                           
                          </td> 
                        </tr>
                      ))}
                    </tbody>
                  </table>

                                   <div className="pagination mt-3" style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                             <button
    disabled={currentPage === 1}
    onClick={() => setCurrentPage((prev) => prev - 1)}
    className="btn btn-primary btn-sm me-2"
  >
    Prev
                     </button>

                      <span> Page {currentPage} of {Math.ceil(courierList.length / itemsPerPage)} </span>

                  <button
    disabled={currentPage === Math.ceil(courierList.length / itemsPerPage)}
    onClick={() => setCurrentPage((prev) => prev + 1)}
    className="btn btn-primary btn-sm ms-2"
  >
    Next
               </button>
</div>
                </div>
              </div>
            </div>
          </div>

           <Modal show={showModal} onHide={handleCloseModal} size="md">
                <Modal.Header closeButton>
                  <Modal.Title>Courier Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {selectedCourier ? (
                    <div>
                        <p>service name:{selectedCourier?.courierServiceName||"N/A"}</p>
                        <p>email:{selectedCourier?.email||"N/A"}</p>
                         <p>contact:{selectedCourier?.contactNumber||"N/A"}</p>
                          <p>city:{selectedCourier?.city||"N/A"}</p>
                           <p>address:{selectedCourier?.addressLine1||"N/A"}</p>
                            <p>gst number:{selectedCourier?.gstNumber||"N/A"}</p>
                    </div>
                  ) : (
                    <p>No details available</p>
                  )}
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleCloseModal}>
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>


              {/* edit modal */}

                <Modal show={editModal} onHide={()=>{setEditModal(false);setSelectedCourier(null)}} size="lg">
                <Modal.Header closeButton>
                  <Modal.Title>Edit Courier Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {selectedCourier ? (
                     <div className="card">
                      <div className="card-header">
                        <h3 className="card-title">Add Basic Information</h3>
                        
                      </div>
                      <form className="card-body" onSubmit={handleSubmit} style={{fontSize:"15px"}}>

                        <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                            Courier Service Name
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              placeholder='Enter Courier Service Name'
                              value={courierServiceName}
                               onChange={(e)=>setCourierServiceName(e.target.value)}
                             
                            />
                          </div>
                        </div>
                         <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                            Contact Person
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              placeholder='Enter Contact Person'
                              value={contactPerson}
                               onChange={(e)=>setContactPerson(e.target.value)}
                             
                            />
                          </div>
                        </div>
                         <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                            Contact number
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              placeholder='Enter Contact number'
                              value={contactNumber}
                               onChange={(e)=>setContactNumber(e.target.value)}
                             
                            />
                          </div>
                        </div>
                         <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                            Email
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              placeholder='Enter Email'
                              value={email}
                               onChange={(e)=>setEmail(e.target.value)}
                             
                            />
                          </div>
                        </div>
                         <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                           Website
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              placeholder='Enter Website'
                              value={website}
                               onChange={(e)=>setWebsite(e.target.value)}
                             
                            />
                          </div>
                        </div>
                         <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                            Address Line 1
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              placeholder='Enter Address'
                              value={addressLine1}
                               onChange={(e)=>setaddressLine1(e.target.value)}
                             
                            />
                          </div>
                        </div>
                         <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                            Address Line 2
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                               placeholder='Enter Address'
                               value={addressLine2}
                               onChange={(e)=>setAddressLine2(e.target.value)}
                             
                            />
                          </div>
                        </div>
                         <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                            City
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                               placeholder='Enter City'
                               value={city}
                               onChange={(e)=>setCity(e.target.value)}
                             
                            />
                          </div>
                        </div>
                         <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                           State
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                               placeholder='Enter State'
                               value={state}
                               onChange={(e)=>setState(e.target.value)}
                             
                            />
                          </div>
                        </div>
                         <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                            Country
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                               placeholder='Enter Country'
                               value={country}
                               onChange={(e)=>setCountry(e.target.value)}
                             
                            />
                          </div>
                        </div>
                         <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                           Postal Code
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                               placeholder='Enter Postal Code'
                               value={postalCode}
                               onChange={(e)=>setPostalCode(e.target.value)}
                             
                            />
                          </div>
                        </div>
                         <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                            Tracking URL
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                               placeholder='Enter Trackng URL'
                               value={trackingUrl}
                               onChange={(e)=>setTrackingUrl(e.target.value)}
                             
                            />
                          </div>
                        </div>
                         <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                          GST Number
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                               placeholder='Enter GST Number'
                               value={gstNum}
                               onChange={(e)=>setGstNum(e.target.value)}
                             
                            />
                          </div>
                        </div>

                         <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                         Status
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                               placeholder='Enter Status'
                               value={status}
                               onChange={(e)=>setStatus(e.target.value)}
                             
                            />
                          </div></div>

                        
                      

                        <div className="col-sm-12">
                          <button type="submit" className="btn btn-primary">
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  ) : (
                    <p>No details available</p>
                  )}
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={()=>{setEditModal(false);setSelectedCourier(null)}}>
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>
        </div>
           <div className="section-body">
          <footer className="footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025{" "}
                  <a href="">Technology support By - Siance Software Pvt Ltd</a>
                  .
                </div>
                {/* <div className="col-md-6 col-sm-12 text-md-right">
                  <ul className="list-inline mb-0">
                    <li className="list-inline-item">
                      <a href="../doc/index.html">Documentation</a>
                    </li>
                    <li className="list-inline-item">
                      <a href="javascript:void(0)">FAQ</a>
                    </li>
                    <li className="list-inline-item">
                      <a
                        href="javascript:void(0)"
                        className="btn btn-outline-primary btn-sm"
                      >
                        Buy Now
                      </a>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
          </footer>
        </div>

                </div>

                
                </div>
      
    </div>
  )
}

export default CourierList
